import { NotificationMessageType, NotificationType } from '@/api/apis/communication';

export const getCaseNotificationLink = (notification: NotificationType) => {
  const { caseId, data } = notification;
  switch (notification.notificationType) {
    case NotificationMessageType.RouteChange:
      return `/case/${caseId}/planner/change-log#${data.RouteLogId}`;
    case NotificationMessageType.RoutePlanningStarted:
    case NotificationMessageType.RoutePlanningCompleted:
      return `/case/${caseId}/planner/change-log`;
    default:
      return `/case/${caseId}`;
  }
};
